import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-upload-complete',
    templateUrl: './upload-complete.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./upload-complete.component.scss'],
})
export class UploadCompleteComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
